import {
  CampaignProductCategoryType,
  CampaignsCampaignProductCategoryProductSupplyChoices,
  CountryType,
  ProductCategoryChoices,
} from "../../graphql/generated";
import { BoxProps, Flex, useDisclosure } from "@chakra-ui/react";
// import { SmartCategoriesIcon } from "../../assets/icons/SmartCategoriesIcon";
// import { ReactsIcon } from "../../assets/icons/ReactsIcon";
// import { CompassIcon } from "../../assets/icons/CompassIcon";
// import { ReactsIcon } from "../../assets/icons/ReactsIcon";
// import { CompassIcon } from "../../assets/icons/CompassIcon";
import { DetailField } from "../../components/detailField/DetailField";
import { DetailFieldListBox } from "../../components/detailFieldListBox/DetailFieldListBox";
import {
  formatDateDisplay,
  formatNumberDisplay,
  formatPrecisionLabel,
  getCreativeTypeDisplay,
  getDSPName,
  getProductLabel,
} from "../../utils/displayGetters";
import { SectionBox } from "../../components/sectionBox/SectionBox";
import { useCampaignInfo } from "./index";
import { CheckedField } from "./CheckedField";
import { EditModal } from "./EditModal";
import { useState } from "react";

export const BasicDetailsSummary = (props: BoxProps) => {
  const { campaign } = useCampaignInfo();
  const markets = campaign.markets.map((m: CountryType) => m.name);
  const smartCategories = campaign.productCategories?.filter(
    (p) => p.productCategory === ProductCategoryChoices.Smart
  );
  // const products = campaign.productCategories.map(
  //   (p: CampaignProductCategoryType) => p.productCategory
  // );
  const precisionCategories = campaign.productCategories?.filter(
    (p) => p.productCategory === ProductCategoryChoices.Precision
  );

  const precisionSmartCategories = campaign.productCategories?.filter(
    (p) => p.productCategory === ProductCategoryChoices.PrecisionSmart
  );

  const precisionCustomCategories = campaign.productCategories?.filter(
    (p) => p.productCategory === ProductCategoryChoices.PrecisionCustom
  );

  const precisionCategoriesCtv = campaign.productCategories?.filter(
    (p) => p.productCategory === ProductCategoryChoices.PrecisionCtv
  );

  // const iconProps = { w: 28, h: 20 };
  // const iconMap = {
  //   [ProductCategoryChoices.Smart]: <Text>[illuma Precision]</Text>, //<SmartCategoriesIcon {...iconProps} />,
  //   [ProductCategoryChoices.SmartCtv]: <Text>[illuma Precision]</Text>, //<SmartCategoriesIcon {...iconProps} />,
  //   [ProductCategoryChoices.Reacts]: <ReactsIcon {...iconProps} />,
  //   [ProductCategoryChoices.Compass]: <CompassIcon {...iconProps} />,
  //   [ProductCategoryChoices.Precision]: <>[illuma Precision]</>,
  //   [ProductCategoryChoices.PrecisionCtv]: <>[illuma Precision]</>,
  // };

  // Modal options. To use modal for a DetailField pass in onOpen and setModalOption
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [modalOption, setModalOption] = useState<string>("");

  const constructProductsList = (
    products: Array<CampaignProductCategoryType>
  ) => {
    const productsString: string[] = products.map((product) =>
      getProductLabel(product.productCategory)
    );
    return productsString;
  };

  return (
    <SectionBox
      // sectionHeader={"Details"}
      p={0}
      {...props}
    >
      <Flex direction={"column"}>
        <DetailField
          label={"Name"}
          value={campaign.name}
          variant={"flex"}
        />
        {/* {products && (
        {/* {products && (
          <HStack>
            {products.map((p: ProductCategoryChoices, ix) => {

              switch(p) {
                case ProductCategoryChoices.Compass:
                  return <CompassIcon key={ix} {...iconProps} />;
                case ProductCategoryChoices.Precision:
                  return <Text key={ix}>[illuma Precision]</Text>;
                case ProductCategoryChoices.PrecisionCtv:
                  return <Text key={ix}>[illuma Precision]</Text>;
                case ProductCategoryChoices.PrecisionCustom:
                  return <Text key={ix}>[illuma Precision (Custom)]</Text>;
                case ProductCategoryChoices.PrecisionSmart:
                  return <Text key={ix}>[illuma Precision (Smart)]</Text>;
                case ProductCategoryChoices.Reacts:
                  return <ReactsIcon key={ix} {...iconProps} />;
                case ProductCategoryChoices.Smart:
                  return <Text key={ix}>[illuma Precision]</Text>;
                case ProductCategoryChoices.SmartCtv:
                  return <Text key={ix}>[illuma Precision]</Text>;
                default:
                  return <Text key={ix}>[illuma Product]</Text>
              }
            })}
            {products.map((p: ProductCategoryChoices, ix) => {

              switch(p) {
                case ProductCategoryChoices.Compass:
                  return <CompassIcon key={ix} {...iconProps} />;
                case ProductCategoryChoices.Precision:
                  return <Text key={ix}>[illuma Precision]</Text>;
                case ProductCategoryChoices.PrecisionCtv:
                  return <Text key={ix}>[illuma Precision]</Text>;
                case ProductCategoryChoices.PrecisionCustom:
                  return <Text key={ix}>[illuma Precision (Custom)]</Text>;
                case ProductCategoryChoices.PrecisionSmart:
                  return <Text key={ix}>[illuma Precision (Smart)]</Text>;
                case ProductCategoryChoices.Reacts:
                  return <ReactsIcon key={ix} {...iconProps} />;
                case ProductCategoryChoices.Smart:
                  return <Text key={ix}>[illuma Precision]</Text>;
                case ProductCategoryChoices.SmartCtv:
                  return <Text key={ix}>[illuma Precision]</Text>;
                default:
                  return <Text key={ix}>[illuma Product]</Text>
              }
            })}
          </HStack>
        )} */}
        {/* Currently all products have the same supply type */}
        <DetailField
          label={"Products"}
          value={constructProductsList(campaign.productCategories)}
          variant={"flex"}
        />
        {campaign.productCategories[0].productSupply &&
          <DetailField
              label={"Supply Type"}
              value={
                campaign.productCategories[0].productSupply === CampaignsCampaignProductCategoryProductSupplyChoices.Web ? "Web" : "CTV"
              }
              variant={"flex"}
          />
        }
        <DetailField
          label={"Advertiser"}
          value={campaign.advertiserName}
          variant={"flex"}
        />
        <DetailField
          label={"Creative Type"}
          value={getCreativeTypeDisplay(campaign.creativeType)}
          variant={"flex"}
        />
        <DetailField
          label={"Markets"}
          value={markets}
          variant={"flex"}
        />
        <DetailField
          label={"DSP"}
          value={getDSPName(campaign.dspInfo.dspName ?? "")}
          variant={"flex"}
        />
        <DetailField
          label={"DSP Member ID"}
          value={campaign.dspInfo.dspMemberId}
          variant={"flex"}
        />
        {campaign.curateInfo && (
          <>
            <DetailField
              label={"SSP"}
              value={getDSPName(campaign.curateInfo.sspName)}
              variant={"flex"}
            />
            <DetailField
              label={"Curate Seat ID"}
              value={campaign.curateInfo.curateSeatId}
              variant={"flex"}
            />
          </>
        )}
        <DetailField
          label={"Start Date"}
          value={formatDateDisplay(campaign.startDate)}
          variant={"flex"}
        />
        <DetailField
          label={"End Date"}
          value={campaign.endDate ? formatDateDisplay(campaign.endDate) : "TBD"}
          openModal={onOpen}
          setModalOption={setModalOption}
          variant={"flex"}
        />
        {smartCategories &&
          smartCategories[0] &&
          smartCategories[0].insightCategories && (
            <DetailField
              label={"Precision Categories"}
              value={smartCategories[0].insightCategories}
              format={true}
              variant={"flex"}
            />
          )}

        {precisionCategories &&
          precisionCategories[0] &&
          precisionCategories[0].precisionCategories && (
            <DetailFieldListBox
              label={"Precision Categories"}
              value={formatPrecisionLabel(
                precisionCategories[0].precisionCategories
              )}
              format={false}
              variant={"flex"}
            />
          )}
        {precisionSmartCategories &&
          precisionSmartCategories[0] &&
          precisionSmartCategories[0].insightCategories && (
            <DetailFieldListBox
              label={"Precision (Smart) Categories"}
              value={precisionSmartCategories[0].insightCategories}
              format={true}
              variant={"flex"}
            />
          )}
        {precisionCustomCategories &&
          precisionCustomCategories[0] &&
          precisionCustomCategories[0].customCategories && (
            <DetailFieldListBox
              label={"Precision (Custom) Categories"}
              value={precisionCustomCategories[0].customCategories}
              format={true}
              variant={"flex"}
            />
            // <CheckedField
            //   label={"Precision (Custom) File Provided"}
            //   value={!!precisionCustomCategories[0].customCategories}
            // />
          )}
        {precisionCategoriesCtv &&
          precisionCategoriesCtv[0] &&
          precisionCategoriesCtv[0].precisionCategories && (
            <DetailField
              label={"Precision CTV Categories"}
              value={formatPrecisionLabel(
                precisionCategoriesCtv[0].precisionCategories
              )}
              format={true}
              variant={"flex"}
            />
          )}
        <DetailField
          label={"Estimated Illuma Budget"}
          value={campaign.estimatedIllumaBudget}
          openModal={onOpen}
          setModalOption={setModalOption}
          variant={"flex"}
        />
        <DetailField
          label={"Estimated Illuma Impressions"}
          value={formatNumberDisplay(campaign.estimatedIllumaImpressions ?? 0)}
          openModal={onOpen}
          setModalOption={setModalOption}
          variant={"flex"}
        />
        <DetailField
          label={"Average CPM"}
          value={campaign.averageCpm}
          openModal={onOpen}
          setModalOption={setModalOption}
          variant={"flex"}
        />
        <CheckedField
          label={"Inclusion List Provided"}
          value={!!campaign.inclusionLists.length}
          manualVariant={"stacked"}
        />
        <CheckedField
          label={"Exclusion List Provided"}
          value={!!campaign.exclusionLists.length}
          manualVariant={"stacked"}
        />
      </Flex>
      <EditModal isOpen={isOpen} onClose={onClose} modalOption={modalOption} />
    </SectionBox>
  );
};
